/**
 * セミナー詳細 セミナー申込方法 1:該当する貴社のセミナーページに送客する
 */
export const SEMINAR_INFORMATION_APPLICATION_PROCESS_URL = {
    annotationLabel: '自社で該当のセミナーページがある場合（成果報酬対象外となります）',
    label: '該当する貴社のセミナーページに送客する',
    value: 1,
};
/**
 * セミナー詳細 セミナー申込方法 2:申込者の情報を別途メールで受け取る
 */
export const SEMINAR_INFORMATION_APPLICATION_PROCESS_EMAIL = {
    annotationLabel: '（申込があった場合は、成果報酬の対象となります）',
    label: '申込者の情報を別途メールで受け取る',
    value: 2,
};
/**
 * セミナー詳細 セミナー申込方法
 */
export const SEMINAR_INFORMATION_APPLICATION_PROCESSES = [
    SEMINAR_INFORMATION_APPLICATION_PROCESS_URL,
    SEMINAR_INFORMATION_APPLICATION_PROCESS_EMAIL,
];
